import React, { useContext } from "react";
import { Button, Tooltip, useToast } from "@chakra-ui/react";

import { UseDataUserContext } from "../../../../_Hooks/_Context/useDataUserAuthenticated";
import { useEnvioInformeJob } from "../../../../_Hooks/_Context/EnvioInformeJobContext";
import useReenviarFallidos from "./reenviarFallidos";

/*
  "Reenviar fallidos (N)": total viene de GET .../fallidos/ (lo consulta quien lo muestra). Sin fallidos no se
  muestra. onStarted: el reenvío quedó en marcha (p. ej. para volver a contar).
*/
const ReenviarFallidosButton = ({ informeId, total, onStarted, size = "xs", ...rest }) => {
  const { useInfoUserAuth } = useContext(UseDataUserContext);
  const token = useInfoUserAuth?.data?.token || "";
  const toast = useToast();
  const envioJob = useEnvioInformeJob();
  const { reenviando, reenviarFallidos } = useReenviarFallidos({ token, toast, envioJob });

  if (!informeId || !(total > 0)) return null;

  const onClick = async () => {
    if (await reenviarFallidos(informeId)) onStarted?.();
  };

  return (
    <Tooltip label="Vuelve a mandar, con el mismo PDF, los mails que no salieron. Respeta el límite por hora.">
      <Button size={size} colorScheme="orange" variant="outline" onClick={onClick} isLoading={reenviando}
        data-testid={`reenviar-fallidos-${informeId}`} {...rest}>
        Reenviar fallidos ({total})
      </Button>
    </Tooltip>
  );
};

export default ReenviarFallidosButton;
